import { Star } from "lucide-react";

export const StarRating = ({ value = 0, onChange, size = "h-5 w-5", testid }) => {
  const interactive = !!onChange;
  return (
    <div className="flex gap-0.5" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" disabled={!interactive} onClick={() => onChange && onChange(n)}
          className={interactive ? "cursor-pointer" : "cursor-default"} data-testid={testid ? `${testid}-${n}` : undefined}>
          <Star className={`${size} ${n <= Math.round(value) ? "fill-accent text-accent" : "text-muted-foreground/40"}`} />
        </button>
      ))}
    </div>
  );
};
